import React, { FC, useEffect, useState } from 'react'
import { IonModal } from '@ionic/react'
import i18n from 'i18next'
import payMobx, { ICard } from '@mobx/pay/pay.mobx'
import { IMenuItemProps } from '../Bill'
import CardItem from './CardItem'
import CardConnectTokenizer from './CardConnectTokenizer'
import HeartlandTokenizer from './HeartlandTokenizer'

const MenuItem: FC<IMenuItemProps> = ({ currentCard, onSelect, onDeleteCard }) => {
  const [showTokenizer, setShowTokenizer] = useState(null)
  const multiUse = payMobx.methodChannelMap.bankCardOnline !== 'HeartLandBankCard' ||
  payMobx.channelAccountMap.HeartLandBankCard && payMobx.channelAccountMap.HeartLandBankCard.tokenType === 'multi'

  const onBackCardAuthorized = async (card: ICard) => {
    onSelect && onSelect('bankCardOnline', card)
    setShowTokenizer(false)
  }

  const authNewCard = async () => {
    if (multiUse) {
      setShowTokenizer(true)
    } else {
      onSelect('bankCardOnline')
    }
  }

  useEffect(() => {
    payMobx.loadAccount(payMobx.methodChannelMap.bankCardOnline)
  }, [])

  return (
    <>
      <li className='group'>
        <div className='group-title' onClick={authNewCard}>
          <img src={require('@img/payment/bankcard.png')} />
          {multiUse ? i18n.t('pay.addBankCard') : i18n.t('pay.bankCard')}
        </div>
        {payMobx.bankCards.length > 0 && (
          <ul className='card-list'>
            {payMobx.bankCards.map(x => (
              <CardItem
                key={x.id}
                card={x}
                isCurrent={currentCard && currentCard.id === x.id}
                onSelect={() => onSelect('bankCardOnline', x)}
                onDelete={() => onDeleteCard('bankCardOnline', x)}
              />
            ))}
          </ul>
        )}
      </li>
      <IonModal isOpen={showTokenizer} cssClass='pay-tokenizer-modal'>
        <div className='close-modal-btn' onClick={() => setShowTokenizer(false)}>
          <i className='iconfont icon-chevron-left' />
        </div>
        {payMobx.methodChannelMap.bankCardOnline === 'CardConnectBankCard' && (
          <CardConnectTokenizer onAuthorize={onBackCardAuthorized} />
        )}
        {payMobx.methodChannelMap.bankCardOnline === 'HeartLandBankCard' && (
          <HeartlandTokenizer multiUse onAuthorize={onBackCardAuthorized} />
        )}
      </IonModal>
    </>
  )
}

export default MenuItem
